import { ChangeDetectorRef, Component, NgZone, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { constants } from "src/app/shared/common/contants";
import { CustomCheckButton } from "src/app/shared/common/Checkbutton";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";
import { ColumnsDialogComponent } from "../product-safety-strategy/columns-dialog/columns-dialog.component";
import { JsignalService } from "src/app/shared/services/jsignal.service";

@Component({
    selector: "app-review-approve",
    templateUrl: "./review-approve.component.html",
    styleUrls: ["./review-approve.component.scss"],
    standalone: false
})
export class ReviewApproveComponent implements OnInit {
  paginationNumberFormatter: any;
  components: any;
  gridAPI: any;
  gridColumnAPI: any;
  gridmgrnAPI: any;
  RunpageSize = 10;
  value: any;
  RuncurrentPage;
  RuntotalPages;
  RunlastPage;
  RunnextPage;
  RunnextPagePlusOne;
  backgroundColorScreen = "";
  backgroundColorButton = "";
  paginationPageSize: any;
  ProductStrategyJson: any;
  isPreview = false;
  docVersion: any;
  // AG-Grid defaults
  defaultColDef = {};
  columnDefs = [];
  // if the record has status==no , row color will change
  rowClassRules = {
    sick: function (params) {
      var numSickDays = params.node.data.status;
      return numSickDays === "No" || numSickDays === null;
    },
  };
  getRowStyle = (params: any) => {
    console.log(params);
    console.log(params.data.status);
    if (params.data.status === "No") {
      return { backgroundColor: "rgb(211, 211, 211)" }; // Inline style for deleted rows
    }
    // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
  };

  gridRowData = [];
  selectedRows = [];
  isDownloading = false;
  rowData: any;
  selectedStrategyId: any;
  toggleableCols: Array<{ headerName: string; field: string }> = [];
  selectedFields: string[] = []; // currently visible fields (for the mat-select)
  currentSectionId: string;
  userRole: string;
  commentCountMap: { [sectionId: string]: number } = {};
  reviewRefreshInterval: any;
  allCommentsJson: any[] = [];
  isFirstLoad: boolean = true;
  id: any;
  //PSSstate to store the PSS State From the grid
  PSSstate: string;
  totalOpenComments: any;
  isSidenavOpen=false;
  constructor(
    private fb: FormBuilder,
    private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private router: Router,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private constants: constants,
    private jsignalsService: JsignalService
  ) {
    this.components = {
      jsignalButton: JSIGNALBUTTON,
    };
  }

  ngOnInit(): void {
    this.intializeGridColumns();
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    this.loadGridData();
  }

  ngOnDestroy(): void {
    if (this.reviewRefreshInterval) {
      clearInterval(this.reviewRefreshInterval);
    }
    //The below condition prevents api call for the selected strategy id after cancel
    this.selectedStrategyId = null;
    this.id = null;
    console.log(this.selectedStrategyId);
    localStorage.removeItem("allCommentsJson");
  }

  checkboxIcon(event: any) {
    const row = event?.rowData;
    //  if (!row) return;

    if (event.checked) {
      // Add row if not already present
      const exists = this.selectedRows.find(
        (r) => r.productStrategyId === row.productStrategyId
      );
      if (!exists) {
        this.selectedRows.push(row);
      }
    } else {
      // Remove row on uncheck
      this.selectedRows = this.selectedRows.filter(
        (r) => r.productStrategyId !== row.productStrategyId
      );
    }

    // Force change detection by creating a new array reference
    this.selectedRows = [...this.selectedRows];

    console.log("Updated selected rows:", this.selectedRows);
  }

  onHeaderCheckboxChange(checked: boolean) {
    const allRowsData = [];

    // Check if filter is active
    const isFilterActive = this.gridAPI.isAnyFilterPresent();

    if (checked) {
      // Select only filtered rows
      if (isFilterActive) {
        this.gridAPI.forEachNodeAfterFilter((node) => {
          node.data.isSelected = true;
          allRowsData.push(node.data);
        });
      } else {
        // Select all rows
        this.gridAPI.forEachNode((node) => {
          node.data.isSelected = true;
          allRowsData.push(node.data);
        });
      }
    } else {
      // Uncheck all rows
      this.gridAPI.forEachNode((node) => {
        node.data.isSelected = false;
      });
      this.selectedRows = [];
    }

    // Refresh only the Action column
    this.gridAPI.refreshCells({
      columns: ["isSelected"],
      force: true,
    });

    console.log(
      "Selected rows data after header checkbox clicked:",
      allRowsData
    );

    // You can store it in a class variable if needed
    this.selectedRows = allRowsData;
    console.log(this.selectedRows);
  }

  EditIcon({ event, rowData }: any): void {
    if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }
  }
  deleteIcon({ event, rowData }: any): void {
    if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }
  }
  onDownloadhistory() {
    if (this.isDownloading) return;

    this.isDownloading = true;
    this.spinner.start();

    setTimeout(() => {
      this.gridmgrnAPI.exportDataAsCsv({
        fileName: "Review_Approve.csv",
      });

      this.spinner.stop();
      this.isDownloading = false;
    }, 500);
  }
  onrefresh() {
    this.loadGridData();
  }
  onPaginationChanged() {
    if (this.gridmgrnAPI && !this.gridmgrnAPI.destroyed) {
      this.RunlastPage = this.gridmgrnAPI.paginationIsLastPageFound();
      this.RuncurrentPage = this.gridmgrnAPI.paginationGetCurrentPage() + 1;
      this.RunnextPage = this.gridmgrnAPI.paginationGetCurrentPage() + 1 + 1;
      this.RunnextPagePlusOne =
        this.gridmgrnAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.RuntotalPages = this.gridmgrnAPI.paginationGetTotalPages();
    }
  }

  onGridReady(params: any) {
    this.gridAPI = params.api;
    this.gridmgrnAPI = params.api;
    this.gridColumnAPI = params.api;
    this.gridmgrnAPI.setGridOption('paginationPageSize', Number(this.RunpageSize));
    // Build the list shown in the dropdown: only columns that have a field and are not pinned left
    this.toggleableCols = this.columnDefs
      .filter((c) => !!c.field && !c.pinned) // keep "Action" out of the picker
      .map((c) => ({ headerName: c.headerName, field: c.field }));

    // Selected = all non-hidden fields by default
    this.selectedFields = this.columnDefs
      .filter((c) => !!c.field && !c.hide)
      .map((c) => c.field);
  }
  onRunSearchChange(searchValue: number) {
    this.gridmgrnAPI.paginationGoToPage(searchValue - 1);
  }
  onRunPageSizeChanged(newPageSize) {
    console.log(this.RunpageSize);
    var value = this.RunpageSize;
    this.gridmgrnAPI.setGridOption('paginationPageSize', Number(value));
  }
  onRunBtFirst() {
    this.gridmgrnAPI.paginationGoToFirstPage();
  }
  onRunBtPrevious() {
    console.log("previous");
    this.gridmgrnAPI.paginationGoToPreviousPage();
  }
  onRunBtNext() {
    console.log("next");
    this.gridmgrnAPI.paginationGoToNextPage();
  }
  onRunBtLast() {
    this.gridmgrnAPI.paginationGoToLastPage();
  }

  downloadWord({ event, rowData }: any): void {}

  loadGridData() {
    this.spinner.start();
    const userId = this.localStorage.getSettings("UserId");

    // getAllProductStrategiesForReview
    this.jsignalsService.getAllProductStrategiesForReview(userId).subscribe({
      next: (res: any[]) => {
        this.gridRowData = res.map((row) => {
          return {
            ...row,
          };
        });
      },
      error: (err) => {
        console.error(" Error loading product strategies:", err);
      },
      complete: () => {
        this.spinner.stop();
      },
    });
  }

  RequestChanges(): void {
    const userId = this.localStorage.getSettings("UserId");
    const rows = Array.isArray(this.selectedRows) ? [...this.selectedRows] : [];
    if (rows.length === 0) {
      return;
    }
    console.log(rows);
  }

  onReview({ event, rowData }: any): void {
    this.spinner.start();
    this.userRole = "reviewer";

    this.selectedStrategyId = rowData.productStrategyId;
    this.id = rowData.id;
    console.log("ProductStrategyId : ", this.selectedStrategyId);

    this.docVersion = rowData.version;
    this.isPreview = true;
    this.PSSstate = rowData.state;
    this.fetchLatestJson();
    //intially load comments
    // this.loadCommentsForStrategy(this.selectedStrategyId);

    // Clear any existing interval before starting a new one
    if (this.reviewRefreshInterval) {
      clearInterval(this.reviewRefreshInterval);
    }

    // Only start Refresh if we actually have a valid ID
    if (this.selectedStrategyId) {
      this.fetchLatestJson();
      // Refresh Json Every 30 Sec
      this.reviewRefreshInterval = setInterval(() => {
        this.fetchLatestJson();
      }, 10000);
    }

    this.spinner.stop();
  }

  fetchLatestJson(): void {
    //The below condition prevents api call for the selected strategy id after cancel
    if (this.selectedStrategyId == null) {
      return;
    }
    console.log("inside fetchLatestJson");
    this.jsignalsService
      .getProductStrategyById(this.selectedStrategyId)
      .subscribe({
        next: (res: any) => {
          // Always clone to force Angular change detection
          // this.ProductStrategyJson = JSON.parse(res.productstrategyJson);
      try {
        // Safely parse JSON
          this.ProductStrategyJson = JSON.parse(res.productstrategyJson);
          console.log("Parsed ProductStrategyJson:", this.ProductStrategyJson);
      } catch (parseError) {
          console.error("Invalid JSON in response:", parseError, res.productstrategyJson);
          this.snackBar.open(`Invalid Json - ${parseError}`, "Ok", {
          duration: 4000,
        });
        // Cancel Review If Any Error Occured 
        this.onReviewCancel();
        return; // stop further processing
      }
          console.log(this.ProductStrategyJson);
        },
        error: (err) => {
          console.error("Failed to fetch latest JSON", err);
          this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
        },
      });
    //Below Method Used To Load the Initial Comment For the Selected Strategy
    // this.selectedStrategyId Is Common id For each PSS
    this.loadCommentsForStrategy(this.selectedStrategyId);
  }

  cancelPreview(resetFlag?: boolean) {
    if (resetFlag) {
      this.isFirstLoad = true; //  reset on cancel
    }
    this.isPreview = false;
    this.ProductStrategyJson = null;
    //The below condition prevents api call for the selected strategy id after cancel
    this.selectedStrategyId = null;
    this.id = null;
    console.log(this.selectedStrategyId);

    localStorage.removeItem("allCommentsJson");
    this.loadGridData();
  }

  handleReviewerAction(event: { id: number; action: string; comment: string }) {
    //   console.log(event);
    //   const commentby = this.localStorage.getSettings('AuthUsername');
    // this.jsignalsService.reviewerAction(event.id, event.action, event.comment,this.docVersion,commentby).subscribe({
    //   next: (res:any) => {
    //      this.snackBar.open(res.statusMessage, 'Ok', { duration: 3000 });
    //       this.loadGridData();
    //     this.cancelPreview(); // optional: close preview after success
    //   },
    //   error: (err) => {
    //     this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
    //      this.loadGridData();
    //     console.error(err);
    //   }
    // });
  }

  openColumnsDialog() {
    const dialogRef = this.dialog.open(ColumnsDialogComponent, {
      maxWidth: "100vw",
      height: "55%",
      width: "45%",
      data: {
        toggleableCols: this.toggleableCols,
        selectedFields: this.selectedFields,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: string[] | undefined) => {
      if (result) {
        this.selectedFields = result;
        this.applySelectionToGrid(); // update AG Grid
      }
    });
  }
  selectAll() {
    this.selectedFields = this.toggleableCols.map((c) => c.field);
    this.applySelectionToGrid();
  }

  clearAll() {
    this.selectedFields = [];
    this.applySelectionToGrid();
  }
  applySelectionToGrid() {
    if (!this.gridColumnAPI) return;

    const selected = new Set(this.selectedFields);

    // toggle only toggleable columns; leave pinned “Action” alone
    for (const c of this.toggleableCols) {
      this.gridColumnAPI.setColumnsVisible([c.field], selected.has(c.field));
    }
  }

  onReviewCancel(resetFlag?: boolean) {
    if (resetFlag) {
      this.isFirstLoad = true; //  reset on cancel
    }
    this.isPreview = false;
    this.ProductStrategyJson = null;
    this.selectedStrategyId = null;
    this.id = null;
    localStorage.removeItem("allCommentsJson");
    this.allCommentsJson = [];
    this.loadGridData();
  }

  onSectionChange(sectionId: string) {
    this.currentSectionId = sectionId; // pass to comments component
    console.log(sectionId);
  }

  onCommentCountsUpdated(counts: { [sectionId: string]: number }) {
    this.commentCountMap = counts;
    console.log(this.commentCountMap);
  }

  loadCommentsForStrategy(strategyId: any): void {
    this.jsignalsService.getComments(strategyId).subscribe({
      next: (res: any) => {
        // Save all comments JSON into allComments[] then pass to comments component
        this.allCommentsJson = res;
        // console.log("Comments loaded for strategy:", strategyId, res.length);
      },
      error: (err) => {
        this.snackBar.open("Failed to load comments", "OK", { duration: 3000 });
        console.error(err);
      },
    });
  }

  onTotalOpenComments(num: any) {
    this.totalOpenComments = num;
    console.log(this.totalOpenComments);
  }

  intializeGridColumns() {
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },sortable: true, resizable: true, filter: true }
    this.columnDefs = [
       {
      headerName: "Action",
      filter: false,
      headerTooltip: "Action",
      cellRenderer: "jsignalButton",
      pinned: "left",
      lockPinned: true,
      // headerComponent:"headerRenderer",
      // headerComponentParams: {
      //   updateCheckbox: this.onHeaderCheckboxChange.bind(this)
      // },
      cellRendererParams: {
        // edit: this.EditIcon.bind(this),
        // delete: this.deleteIcon.bind(this),
        onReview: this.onReview.bind(this),

        // onCheckboxChange:this.checkboxIcon.bind(this)
      },
      width: 120,
      hide: false,
    },

    {
      headerName: "PSS Name",
      field: "productStrategyName",
      filter: "agTextColumnFilter",
      headerTooltip: "PSS Name",
      tooltipValueGetter: (params) => "PSS Name : " + params.value,
      width: 200,
      hide: false,
    },
    {
      headerName: "Product Name",
      field: "productName",
      filter: "agTextColumnFilter",
      headerTooltip: "Product Name",
      tooltipValueGetter: (params) => "Product Name : " + params.value,
      hide: false,
      width: 200,
    },
    {
      headerName: "Product State",
      field: "productState",
      filter: "agTextColumnFilter",
      headerTooltip: "Product State",
        tooltipValueGetter: (params) => {
        const value = params.value;
        if (value === "active__v") return "Product State : Active";
        if (value === "inactive__v") return "Product State : Inactive";
        return "Product State : " + (value || "");
      },
      hide: false,
      width: 180,

      //Custom cell renderer for colored label
      cellRenderer: (params) => {
        const value = params.value;
        if (value === "active__v") {
          return `<span style="color: green; font-weight: 600;">Active</span>`;
        }
        return `<span>${value || ""}</span>`;
      },

      // Optional: make sure raw value (not HTML) is used for filtering/sorting
      cellRendererParams: { suppressHtmlEscaping: false },
    },
    {
      headerName: "Version",
      field: "version",
      filter: "agTextColumnFilter",
      headerTooltip: "Version",
      tooltipValueGetter: (params) => "Version : " + params.value,
      width: 100,
      hide: false,
    },
    {
      headerName: "State",
      field: "state",
      headerTooltip: "State",
      tooltipValueGetter: (params) => "State : " + params.value,
      width: 160,
      cellRenderer: (params: any) => {
        const state = params.data.state; // display text
        const stateCode = params.data.stateCode; // color based on this
        let badgeClass = "";

        // Map stateCode to badge classes
        switch (stateCode) {
          case "1":
            badgeClass = "state-badge draft";
            break;
          case "2":
            badgeClass = "state-badge review";
            break;
          case "3":
            badgeClass = "state-badge approval";
            break;
          case "4":
            badgeClass = "state-badge approved";
            break;
          case "5":
            badgeClass = "state-badge superseded";
            break;
          default:
            badgeClass = "state-badge default";
        }

        return `
      <span class="${badgeClass}">
        <span class="dot"></span>${state}
      </span>`;
      },
    },
    {
      headerName: "Start Date",
      field: "createdDate",
      filter: "agNumberColumnFilter",
      headerTooltip: "Start Date",
      tooltipValueGetter: (params) => "Start Date : " + params.value,
      hide: true,
      width: 180,
    },
    {
      headerName: "Due Date",
      field: "duedate",
      filter: "agNumberColumnFilter",
      headerTooltip: "Due Date",
      tooltipValueGetter: (params) => "Due Date : " + params.value,
      hide: true,
      width: 180,
    },
    // {
    //   headerName: "End Date",
    //   field: "enddate",
    //   filter: "agNumberColumnFilter",
    //   tooltipField: "enddate",
    //   hide: true,
    //   width: 180,
    // },
    {
      headerName: "Author",
      field: "author",
      filter: "agNumberColumnFilter",
      headerTooltip: "Author",
      tooltipValueGetter: (params) => "Author : " + params.value,
      hide: false,
      width: 180,
    },
    // {
    //   headerName: "Download",
    //   headerTooltip: "Download Word Document",
    //   cellRenderer: "jsignalButton",
    //   cellRendererParams: {
    //     onWord: this.downloadWord.bind(this),
    //   },
    //   hide: false,
    //   width: 150,
    // },
    {
      headerName: "Last Modified By",
      field: "lastModifiedBy",
      filter: "agNumberColumnFilter",
      headerTooltip: "Last Modified By",
      tooltipValueGetter: (params) => "Last Modified By : " + params.value,
      hide: false,
      width: 180,
    },
    {
      headerName: "Last Modified Date",
      field: "lastModifiedDate",
      filter: "agNumberColumnFilter",
      headerTooltip: "Last Modified Date",
      tooltipValueGetter: (params) => "Last Modified Date : " + params.value,
      hide: false,
      width: 180,
    },
    // {
    //   headerName: "Comments",
    //   field: "comments",
    //   cellRenderer: (params) => {
    //     const val = params.value;
    //     if (!val) return "";

    //     if (typeof val === "object") {
    //       return Object.entries(val)
    //         .map(([role, msgs]) => {
    //           if (Array.isArray(msgs)) {
    //             return `${role}: ${msgs.join("; ")}`;
    //           } else {
    //             return `${role}: ${msgs}`;
    //           }
    //         })
    //         .join(" | ");
    //     }
    //     return val;
    //   },
    //   tooltipValueGetter: (params) => {
    //     const val = params.value;
    //     if (!val) return "";
    //     if (typeof val === "object") {
    //       return Object.entries(val)
    //         .map(([role, msgs]) => {
    //           if (Array.isArray(msgs)) {
    //             return `${role}:\n - ${msgs.join("\n - ")}`;
    //           } else {
    //             return `${role}: ${msgs}`;
    //           }
    //         })
    //         .join("\n");
    //     }
    //     return val;
    //   },
    //   hide: false,
    //   width: 180,
    // },
    // { headerName: 'Review Status', field: 'reviewStatus', flex: 1, filter: 'agNumberColumnFilter',tooltipField:'reviewStatus',width: 40 },
    ]
  }
}
